import PropTypes from "prop-types";
import { Container } from "@mui/material";
import Masonry from "@mui/lab/Masonry";
import { styled } from "@mui/material/styles";

import { useScreen, useTrackAccountEvents, useUsers } from "hooks";

import MasonryItem from "../MasonryItem";

const Root = styled(Container)({
  margin: "auto",
});

const MasonryGrid = ({ hits, modulePosition }) => {
  const { isDesktop, isMobile, isTablet } = useScreen();
  const { trackSelectItemEvents } = useTrackAccountEvents();
  const { currentUser } = useUsers();
  const hasModulePosition = Boolean(modulePosition);
  const handleClick = (item, index) => {
    trackSelectItemEvents(currentUser, item, modulePosition ? `${modulePosition}:${index + 1}` : undefined);
  };

  const getCols = () => {
    switch (true) {
      case isDesktop:
        return 5;
      case isTablet:
        return 4;
      case isMobile:
        return 2;
      default:
        return 2;
    }
  };

  return (
    <Root>
      <Masonry columns={getCols()} spacing={1.875}>
        {hits?.map((card, index) => (
          <MasonryItem
            key={card.objectID}
            card={card}
            onClick={hasModulePosition ? () => handleClick(card, index) : undefined}
            hasModulePosition={hasModulePosition}
          />
        ))}
      </Masonry>
    </Root>
  );
};

MasonryGrid.propTypes = {
  hits: PropTypes.arrayOf(PropTypes.shape()),
  modulePosition: PropTypes.number,
};

export default MasonryGrid;
